import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SignupForm from "../components/SignupForm";
import { signup } from "../services/authService";
import Layout from "../pages/Layout";
import { Helmet } from "react-helmet";

const Signup = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // ✅ To handle success/error styling
  const navigate = useNavigate();

  const handleSignup = async (formData) => {
    setLoading(true);
    setMessage("");

    try {
      const result = await signup(formData);
      if (result.success) {
        setMessageType("success"); // ✅ Success message type
        setMessage(result.message);
        setTimeout(() => {
          navigate("/login");
        }, 7000000);
      } else {
        setMessageType("error"); // ✅ Error message type
        setMessage(result.message);
      }
    } catch (error) {
      setMessageType("error");
      setMessage(error || "Error connecting to the server.");
    }

    setLoading(false);
  };

  return (
    <div className="signup-page">
      <Helmet>
        <title>Signup - Factbazaar</title>
        <meta name="description" content="Sign up to access the latest news and updates." />
      </Helmet>
      <Layout>
        <SignupForm onSubmit={handleSignup} loading={loading} />
        
        {/* ✅ Styled Message Box */}
        {message && (
          <div className={`alert ${messageType === "success" ? "alert-success" : "alert-danger"} mt-3 text-center`}>
            {message}
          </div>
        )}
      </Layout>
    </div>
  );
};

export default Signup;
